export type NumberFieldState = string;

export function isValidIntegerString(value: string): boolean {
  if (!value || value.trim() === '') return true;
  return /^\d+$/.test(value.trim());
}

export function validateIntegerString(value: string): {
  isValid: boolean;
  error?: string;
} {
  if (!value || value.trim() === '') {
    return { isValid: true };
  }

  const trimmed = value.trim();
  if (!/^\d+$/.test(trimmed)) {
    const invalidChar = trimmed.match(/[^\d]/)?.[0];
    return {
      isValid: false,
      error: invalidChar
        ? `"${invalidChar}" is not a valid number. Only whole numbers are allowed.`
        : 'Only whole numbers are allowed.',
    };
  }

  return { isValid: true };
}

export function parseIntegerString(value: string): number {
  if (!value || value.trim() === '') return 0;
  const parsed = Number.parseInt(value.trim(), 10);
  return Number.isNaN(parsed) ? 0 : Math.max(0, parsed);
}

export function formatTimeInput(value: string): string {
  let cleaned = value.replace(/[^\d:]/g, '');
  if (cleaned.length === 1 && Number.parseInt(cleaned, 10) > 2) {
    cleaned = `0${cleaned}`;
  }
  if (cleaned.length === 2 && !cleaned.includes(':')) {
    const hours = Number.parseInt(cleaned, 10);
    if (hours > 23) {
      cleaned = '23';
    }
    cleaned = `${cleaned}:`;
  }
  if (cleaned.length === 4 && cleaned[3] !== ':') {
    const minutes = Number.parseInt(cleaned.slice(3), 10);
    if (minutes > 59) {
      cleaned = `${cleaned.slice(0, 3)}59`;
    }
  }
  return cleaned.slice(0, 5);
}
